import { useEffect } from 'react';

import { AccessibilityInfo, EmitterSubscription, Platform } from 'react-native';

import { useDispatch } from 'react-redux';

import {
    setReduceMotionEnabled,
    setScreenReaderEnabled,
} from 'store/config/actions';

function useAccessibilitySettings() {
    const dispatch = useDispatch();

    const handleSetReduceMotionEnabled = (enabled: boolean) => {
        dispatch(setReduceMotionEnabled(enabled));
    };

    const handleSetScreenReaderEnabled = (enabled: boolean) => {
        dispatch(setScreenReaderEnabled(enabled));
    };

    useEffect(() => {
        let reduceMotionChangedSubscription: EmitterSubscription;
        let screenReaderChangedSubscription: EmitterSubscription;

        if (Platform.OS === 'ios' || Platform.OS === 'android') {
            reduceMotionChangedSubscription =
                AccessibilityInfo.addEventListener(
                    'reduceMotionChanged',
                    handleSetReduceMotionEnabled,
                );
            screenReaderChangedSubscription =
                AccessibilityInfo.addEventListener(
                    'screenReaderChanged',
                    handleSetScreenReaderEnabled,
                );

            AccessibilityInfo.isReduceMotionEnabled().then(
                handleSetReduceMotionEnabled,
            );
            AccessibilityInfo.isScreenReaderEnabled().then(
                handleSetScreenReaderEnabled,
            );
        }

        return () => {
            if (Platform.OS === 'ios' || Platform.OS === 'android') {
                reduceMotionChangedSubscription?.remove();
                screenReaderChangedSubscription?.remove();
            }
        };
    }, []);
}

export default useAccessibilitySettings;
